import { render } from "./ConditionsOfThisAuthority.vue?vue&type=template&id=4da940b9&ts=true"
import script from "./ConditionsOfThisAuthority.vue?vue&type=script&lang=ts"
export * from "./ConditionsOfThisAuthority.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__